(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-login/assets/javascripts/views/freja/poll.js') >= 0) return;  svs.modules.push('/modules/player-login/assets/javascripts/views/freja/poll.js');

'use strict';

const {
  Events: AuthenticateEvents
} = svs.accountservices.authenticate.definitions;
svs.player_login.views.freja.Poll = Marionette.View.extend({
  template(data) {
    return svs.player_login.templates.freja_poll(data);
  },
  ui: {
    loader: '.js-loader-container',
    openAppButton: '.js-open-app'
  },
  events: {
    'click @ui.openAppButton': 'onOpenAppClick'
  },
  behaviors: {
    About: {
      behaviorClass: svs.player_login.behaviors.About
    },
    Login: {
      behaviorClass: svs.player_login.behaviors.Login
    },
    Navigation: {
      behaviorClass: svs.player_login.behaviors.Navigation
    }
  },
  initialize() {
    delete this.loader;
  },
  onBeforeError() {
    if (this.loader) {
      this.loader.hide();
    }
  },
  onAttach() {
    const isPnpMobile = this.model.get('isPnpMobile');
    this.loader = new svs.ui.Loader(this.getUI('loader'));
    this.loader.show(300, isPnpMobile ? '' : 'inverted');
    if (svs.accountservices.authenticate.login.isStarted()) {
      svs.utils.url.navigate(svs.accountservices.authenticate.login.getAppUrl());
      svs.accountservices.authenticate.login.poll();
    } else {
      svs.accountservices.authenticate.login.on(AuthenticateEvents.READY_TO_POLL, this.onReadyToPoll, this);
      svs.accountservices.authenticate.login.on(AuthenticateEvents.NO_RESUME, this.onError, this);
      svs.accountservices.authenticate.login.resumePendingLogin();
    }
  },
  onError() {
    if (svs.core.detect.formfactor.mobile()) {
      this.triggerMethod('do:navigation', '/');
    } else {
      this.triggerMethod('do:navigation', '/freja');
    }
  },
  onReadyToPoll() {
    svs.accountservices.authenticate.login.poll();
  },
  onOpenAppClick(e) {
    e.preventDefault();
    svs.utils.url.navigate(svs.accountservices.authenticate.login.getAppUrl());
  },
  onDestroy() {
    svs.accountservices.authenticate.login.off(AuthenticateEvents.READY_TO_POLL, this.onReadyToPoll);
    svs.accountservices.authenticate.login.off(AuthenticateEvents.NO_RESUME, this.onError);
    svs.accountservices.authenticate.login.cancel();
  }
});

 })(window);